import { render, staticRenderFns } from "./VirusPods.vue?vue&type=template&id=223c665c&scoped=true&"
import script from "./VirusPods.vue?vue&type=script&lang=ts&"
export * from "./VirusPods.vue?vue&type=script&lang=ts&"
import style0 from "./VirusPods.vue?vue&type=style&index=0&id=223c665c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c665c",
  null
  
)

export default component.exports